import { useNavigate } from "@remix-run/react";
import React, { useEffect, useState } from "react";
import SchoolUpdatesView from "./SchoolUpdatesView";
import { schoolUpdatesAPI } from "../../../api/task-services";
import { isNotEmptyOrNull, urlString } from "../../../utils/common-utils";

const SchoolUpdatesPresenter = ({
  handleTaskClick,
  setTaskType,
  setSubTopicName,
  setTopicName,
  setTaskCatagory,
  setSelectedIndex,
  setSubject,
  setSubjectMasterUUid,
  setTopicMasterUuid,
  setUpdates,
}) => {
  const navigate = useNavigate();
  const [sortedSchoolUpdates, setSortedSchoolUpdates] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const schoolUpdates = async () => {
    try {
      setIsLoading(true);
      const updatesData = await schoolUpdatesAPI();
      const fetchedTotalUpdates = updatesData?.school_updates;
      const sectionUpdates = fetchedTotalUpdates?.section_level_updates;
      const studentUpdates = fetchedTotalUpdates?.student_level_updates;
      const mergedUpdates = [...sectionUpdates, ...studentUpdates].sort(
        (a, b) => {
          // Customize the sort logic based on your requirement.
          // For example, if sorting by date:
          return new Date(b?.timestamp) - new Date(a?.timestamp);
        }
      );
      setSortedSchoolUpdates(mergedUpdates);
      setUpdates(mergedUpdates); // for parent component
    } catch (e) {
      console.log("ERROR", e);
    } finally {
      setIsLoading(false);
    }
  };

  const onhandleUpdateClick = (item) => {
    // FOR TASKS
    if (item?.update_type !== "sectionUnlocked") {
      if (
        isNotEmptyOrNull(
          item?.update_data?.taskAttributes?.experientialLearning
        ) &&
        item?.update_data?.taskStatus === "completed"
      ) {
        navigate(`${urlString}/wall/wall-detailed-page`, {
          state: {
            postTaskData: item?.update_data,
          },
        });
      } else {
        setTaskType(item?.update_data?.taskType);
        let taskType = item?.update_data?.taskType;
        if (taskType === "LearnSubTopic") {
          setSelectedIndex(1);
        } else if (taskType === "GuidedPractise") {
          setSelectedIndex(4);
        } else if (taskType === "Assessment") {
          setSelectedIndex(5);
        }
        setSubTopicName(item?.update_data?.taskAttributes?.subtopicName);
        setTopicName(item?.update_data?.taskAttributes?.topicName);
        setSubject(item?.update_data?.taskAttributes?.subjectName);
        setTaskCatagory(item?.update_data?.taskType);
        setSubjectMasterUUid(item?.update_data?.subjectId);
        setTopicMasterUuid(item?.update_data?.taskAttributes?.topicMasterUuid);

        handleTaskClick(
          item?.update_data?._id,
          item?.update_data?.taskId,
          item?.update_data?.taskAttributes?.topicName,
          item?.update_data?.taskAttributes?.gradeName,
          item?.update_data?.taskAttributes?.subjectName,
          item?.update_data?.journeyId,
          item?.update_data?.taskStatus,
          item?.update_data?.subjectId,
          item?.update_data?.taskAttributes?.experientialLearning,
          item?.update_data?.taskType,
          item?.update_data
        );
      }
    } else if (item?.update_type === "sectionUnlocked") {
      let unlockProps = {
        updateData: item?.update_data,
        fromUpdates: true,
      };
      navigate(`${urlString}/syllabus`, {
        state: {
          unlockProps: unlockProps,
        },
      });
    }
  };

  useEffect(() => {
    schoolUpdates();
  }, []);

  if (isLoading) {
    return null;
  }

  return (
    <SchoolUpdatesView
      data={sortedSchoolUpdates}
      onhandleUpdateClick={onhandleUpdateClick}
    />
  );
};

export default SchoolUpdatesPresenter;
